import type { GetAllCardsResponse, GetProductsResponse, ImagesType } from '@shared/api';

export class CardUtils {
  static getColor = (card: GetAllCardsResponse, products: GetProductsResponse[]) =>
    products.find((product) => product.id === card.productId)?.textColor || '#fff';

  static renderBackgroundImg = (item: GetAllCardsResponse, products: GetProductsResponse[], imageType: keyof ImagesType = 'front'): string => {
    const product = products.find((product) => product.id === item.productId);
    const bg = product?.images?.[imageType] ?? '';
    return `${process.env.API_URL}/${bg}`;
  };
}
